import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    ? { measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID }
    : {}),
};

if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.error(
    'Firebase config missing. Set REACT_APP_FIREBASE_* variables in .env (see .env.example).'
  );
}

function getOrInitApp() {
  const { projectId } = firebaseConfig;
  const existing = getApps();

  if (existing.length === 0) {
    return initializeApp(firebaseConfig);
  }

  const defaultApp = getApp();
  if (defaultApp.options.projectId === projectId) {
    return defaultApp;
  }

  const matching = existing.find((a) => a.options?.projectId === projectId);
  if (matching) {
    return matching;
  }

  return initializeApp(firebaseConfig, projectId);
}

const app = getOrInitApp();

if (process.env.NODE_ENV === 'development') {
  console.info('[Firebase] project:', app.options.projectId);
}

const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
